<template lang="pug">
	ul.table__row.msg-table
		li.table__col( data-table="msg" )
			.teams-report__text
				p.table__text.msg-table-text {{data[0].profit}}
		li.table__col.msg-table-row(v-for="(mth, idx) in getMonth "  data-table="msg" )
			.msg-table-col(v-for="(col, index) in item[mth.id]")
				Percents( :value="calcPercentProfit(col.profit, idx, index)" )
				p.table__text.msg-label(v-if="!currentDay(mth, index)") {{ col.profit != 0 || col.profit ? col.profit : 0 }}
				input.table__text.msg-input.msg-label(
					v-else
					v-model="col.profit"
					@input="writeSumm($event.target.value,col)"
					@blur="blur(col, idx)"
					placeholder="0"
					:class="[col.profit == 0 && 'table__text_default']"
					type="text"
				)
				.msg-input-after
					| &#8381;
		li.table__col(  data-table="msg" )
			.teams-report__text
				p.table__text {{summCol}}
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  props: {
    data: {},
    isUpdate: {
      type: Boolean,
      default: false
    },
    info: {}
  },
  data() {
    return {
      count: 0,
      item: {},
      month: [
        {
          id: 9,
          title: 'Сентябрь'
        },
        {
          id: 10,
          title: 'Октябрь'
        },
        {
          id: 11,
          title: 'Ноябрь'
        },
        {
          id: 12,
          title: 'Декабрь'
        },
        {
          id: 1,
          title: 'Январь'
        },
        {
          id: 2,
          title: 'Февраль'
        },
        {
          id: 3,
          title: 'Март'
        },
        {
          id: 4,
          title: 'Апрель'
        },
        {
          id: 5,
          title: 'Май'
        },
        {
          id: 6,
          title: 'Июнь'
        },
        {
          id: 7,
          title: 'Июль'
        },
        {
          id: 8,
          title: 'Август'
        }
      ]
    };
  },
  computed: {
    summCol() {
      return Object.values(this.item)
        .flat(3)
        .map(el => {
          if (el.profit == 0 || !el.profit) {
            return 0;
          }
          return el.profit;
        })
        .reduce((prev, next) => {
          if (isNaN(parseInt(prev)) || isNaN(parseInt(next))) {
            return 0;
          }

          return +prev + +next;
        }, 0);
    },
    currentDate() {
      return moment().date();
    },
    currentMonth() {
      return moment().month();
    },
    createdAtMoment() {
      return moment(this.info.createdAt, 'DD.MM.YYYY');
    },
    isCurrent() {
      let infoYear = moment().year();
      if (this.info.createdAt) {
        infoYear = this.createdAtMoment.format('YYYY-MM-DD');
      }

      return moment(moment().format('YYYY-MM-DD')).isSameOrAfter(infoYear);
    },
    getMonth() {
      const month = [...this.month];
      if (this.period == 1) {
        return month.splice(0, 6);
      } else {
        return month.splice(6, 11);
      }
    },
    period() {
      if (this.$route.query.period) {
        return this.$route.query.period;
      }
      return 1;
    }
  },
  watch: {
    data() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      const data = this.data.filter(el => el.weekId !== -1);
      const sameObj = {};
      if (typeof this.getMonth[this.count] !== 'undefined') {
        for (let i = 0; i < data.length; i++) {
          const id = this.getMonth[this.count].id;
          if (sameObj[id]) {
            sameObj[id] = [...sameObj[id], data[i]];
          } else {
            sameObj[id] = [data[i]];
          }

          if (i % 2 != 0) {
            this.count += 1;
          }
        }
      }
      this.item = _.cloneDeep(sameObj);
      this.getItemArray;
      this.count = 0;
    },
    currentDay(month, idx) {
      const monthBoolean = this.calcMonth(month);
      const boolean = monthBoolean && this.calcDay(idx, month);

      return monthBoolean && boolean;
    },
    calcDay(idx, month) {
      let currBoolean = false;
      let monthBoolean = false;
      let year = this.$route.query.year;
      const date = idx === 0 ? '01' : '15';
      if (month.id <= 7) {
        year = +this.$route.query.year + 1;
      }

      const str = `${year}-${
        month.id >= 10 ? month.id : '0' + month.id
      }-${date}`;
      const strCreatedAd = `${this.createdAtMoment.year()}-${
        +this.createdAtMoment.month() + 1 >= 10
          ? +this.createdAtMoment.month() + 1
          : '0' + this.createdAtMoment.month()
      }-${this.createdAtMoment.date() >= 15 ? '15' : '01'}`;
      monthBoolean = moment(moment(str).format('YYYY-MM-DD')).isSameOrAfter(
        strCreatedAd
      );
      currBoolean = moment(moment(str).format('YYYY-MM-DD')).isSameOrBefore(
        moment().format('YYYY-MM-DD')
      );

      return currBoolean && monthBoolean;
    },
    calcMonth(month) {
      let currBoolean = false;
      let monthBoolean = false;
      let year = this.$route.query.year;
      if (month.id <= 7) {
        year = +this.$route.query.year + 1;
      }

      const str = `${year}-${month.id >= 10 ? month.id : '0' + month.id}-${
        this.currentDate >= 10 ? this.currentDate : '0' + this.currentDate
      }`;
      const strCreatedAd = `${this.createdAtMoment.year()}-${
        this.createdAtMoment.month() >= 10
          ? this.createdAtMoment.month()
          : '0' + this.createdAtMoment.month()
      }-${this.createdAtMoment.date() >= 15 ? '15' : '01'}`;
      monthBoolean = moment(moment(str).format('YYYY-MM-DD')).isSameOrAfter(
        moment(strCreatedAd)
      );
      currBoolean = moment(moment(str).format('YYYY-MM-DD')).isSameOrBefore(
        moment().format('YYYY-MM-DD')
      );

      return currBoolean && monthBoolean;
    },
    writeSumm(event, val) {
      if (!isNaN(parseFloat(event))) {
        val.profit = parseFloat(event);
      }
      // if(event.match(/\d*/))
      // 	val.profit = event.match(/\d*/)[0]
    },
    calcPercentProfit(profit, idx, index) {
      profit = profit != 0 || profit ? profit : 0;
      const mth =
        this.getMonth[idx] > 0 ? this.getMonth[idx - 1] : this.getMonth[idx];
      let prevProfit;
      if (idx === 0 && index === 0) {
        prevProfit = profit ? profit : 0;
      } else if (idx === 0 && index !== 0) {
        prevProfit = this.item[mth.id - 1]
          ? this.item[mth.id - 1][index + 1].profit
          : 0;
      } else {
        prevProfit = this.item[mth.id][index - 1]
          ? this.item[mth.id][index - 1].profit
          : 0;
      }

      return this.choosingPercent(profit, prevProfit);
    },
    choosingPercent(profit = 0, prevProfit = 0) {
      if (prevProfit == 0 || profit == 0) {
        return 0;
      }

      return ((profit / prevProfit) * 100).toFixed(2);
    },
    blur(object, idx) {
      if (object.profit === 0) {
        object.profit = '';
      }
      if (this.data[idx].profit == object.profit) {
        return;
      }

      this.$store.dispatch('msg/setMeta', { path: 'isUpdate', value: false });
      this.sendData(object);
    },
    sendData(col) {
      this.$store.dispatch('msg/setTractionMsgWeeks', {
        weekId: col.weekId,
        id: col.id,
        profit: col.profit
      });
    }
  }
};
</script>
